<template>
    <div class="">
        <label :for="id">
            <span>Country</span>
            <i v-if="info" class="fa fa-info-circle text-muted" data-toggle="tooltip" data-placement="right" :title="info"></i>
        </label>
        <select :name="name" :id="id" :class="className" @change="onChange" ref="select">
            <option value="0">Select</option>
            <slot></slot>
            <option v-if="canAddCountry" value="modal">Add a new record</option>
        </select>
        <div class="invalid-feedback" v-if="phpError">{{ phpError }}</div>

        <Modal title="Add new country" :show="showModal" @close="onClose">
            <form @submit="onSubmit">
                <text-input name="description" label="Country" :error="errors.description ? errors.description[0] : ''" v-model="form.description" ref="textInputRef" />
                <text-input name="key" label="Abbreviation" :error="errors.key ? errors.key[0] : ''" v-model="form.key" />
            </form>

            <template v-slot:footer>
                <button class="btn btn-primary" @click="onSubmit">Submit</button>
                <button class="btn btn-link" @click.prevent="onClose">Close</button>
            </template>
        </Modal>
    </div>
</template>

<script>
import Modal from "./Modal";
import { EventBus } from '../event-bus.js';
import TextInput from './Inputs/TextInput.vue';

export default {
    name: "CountryDropdown",
    props: {
        name: { type: String, required: true },
        id: { type: String, required: true },
        className: { type: String, default: '', required: false },
        phpError: { type: String, default: '', required: false },
        info: { type: String, default: '', required: false },
        canAddCountry: { type: Boolean, default: false, required: false}
    },
    components: {
        Modal,
        TextInput,
    },
    data() {
        return {
            showModal: false,
            form: {
                key: '',
                description: '',
            },
            errors: {},
            lastSelected: 0,
        };
    },
    mounted() {
        this.lastSelected = this.$refs.select.selectedIndex;
    },
    methods: {
        onChange(event) {
            if (event.target.value == 'modal') {
                this.showModal = true;
                event.target.selectedIndex = this.lastSelected;

                this.$nextTick(() => {
                    this.$nextTick(() => {
                        this.$refs.textInputRef.$refs.input.focus();
                    });
                });
            } else {
                this.lastSelected = event.target.selectedIndex;
                EventBus.$emit('country-changed', this.$refs.select.options[this.lastSelected].text, this.$refs.select.options[this.lastSelected].value);
            }

        },
        onSubmit(event) {
            event.preventDefault();

            let params = JSON.parse(JSON.stringify(this.form));//deep clone
            params.whitelist_value = this.whitelistValue;

            axios.post('/api/countries', params).then(response => {
                this.errors = {};
                this.form.key = '';
                this.form.description = '';
                this.onClose();
                this.$refs.select.innerHTML = '';
                var selectedIndex = 0;


                response.data.data.forEach((element, index) => {
                    this.$refs.select.add(new Option(element.description, element.value, element.selected));

                    if (element.selected) {
                        EventBus.$emit('country-added', element.description, element.value);
                        selectedIndex = index;
                    }
                });

                this.$refs.select.add(new Option('Add a new record', 'modal'));
                this.$refs.select.selectedIndex = selectedIndex;
                this.lastSelected = selectedIndex;
            }).catch(error => {
                if (error.response && error.response.status == 422) {
                    this.errors = error.response.data.errors;
                }
            });
        },
        onClose() {
            this.showModal = false;
            this.$refs.select.focus();
        },
    }
}
</script>